import React from "react";
import "./progressBar.scss";

const ProgressBar = (props: TooltipInterface) => {
    const { step, formValues, requiredValues, fieldsToSkip } = props;

    const getProgress = () => {
        let count = 0;
        Object.keys(formValues).forEach((key) => {
            if (requiredValues.includes(key) && formValues[key]) {
                count++;
            }
        });
        const values = requiredValues.filter(value => !fieldsToSkip?.includes(value));
        if (fieldsToSkip && fieldsToSkip.length > 0){
            return Math.trunc((count / values.length) * 100);
        } else {
            return Math.trunc((count / Object.keys(requiredValues).length) * 100);
        }
    };

    const fillerStyles = {
        width: `${getProgress()}%`,
    };

    return (
        <div className="progress-bar">
            <div>
                {step && (
                    <>
                        <span className="progress-bar-step">Paso {step}</span>
                        <br className="line-break" />
                    </>
                )}
                <span className="progress-bar-percentage">{`${getProgress()}% completado`}</span>
            </div>
            <div className="progress-bar-container">
                <div style={fillerStyles} className="progress-bar-filler">
                    <span className="progress-bar-label"></span>
                </div>
            </div>
        </div>
    );
};

interface TooltipInterface {
    step?: number;
    formValues: {};
    requiredValues: string[];
    fieldsToSkip?: string[];
}

export default ProgressBar;
